var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#DEC799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2356 7.54537L12.4341 3.9375L10.8608 6.42037C9.63764 6.12505 8.3618 6.12505 7.13869 6.42037L5.56988 3.9375L4.7655 7.54537C3.90206 8.23612 3.375 9.13894 3.375 10.1301C3.375 12.3013 5.89275 14.0614 8.99831 14.0614C12.1039 14.0614 14.6216 12.3008 14.6216 10.1301C14.6211 9.13894 14.0985 8.23612 13.2351 7.54537H13.2356ZM5.87363 9.19688H5.499L6.41419 8.14162H7.08019L5.87363 9.19688ZM8.96962 11.7754L7.41375 9.03487L7.79794 8.8155L8.145 9.42581H9.84431L10.2066 8.81269L10.5868 9.03881L8.96962 11.7754ZM12.1269 9.19688L10.9198 8.14162H11.5903L12.5044 9.19688H12.1269ZM8.97694 10.8928L8.39587 9.86906H9.58162L8.97694 10.8928Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMona);
export default __webpack_public_path__ + "static/media/mona.16b80ebd162f0d906df3bc7be446d20a.svg";
export { ForwardRef as ReactComponent };